import type { NavigationGuardNext } from "vue-router";
import { getOnBoardRoute } from "@/router/onBoardingRoute";

export default async function requireOnBoarding({
  next,
  companyStore,
}: {
  next: NavigationGuardNext;
  companyStore: any;
}) {
  // On a fresh page load the store starts empty and the guard used to pass
  // through, leaving a reopened-onboarding company on the app screens until
  // something else refetched. Resolve the status once before deciding.
  if (companyStore.companyOnboardingStatus === "" && localStorage.getItem("companyId")) {
    try {
      await companyStore.getCompany();
    } catch (e) {
      /* getCompany swallows its own errors; stay permissive on failure */
    }
  }

  if (companyStore.companyOnboardingStatus === "") {
    return next();
  }

  if (companyStore.companyOnboardingStatus !== "COMPLETE") {
    let routeName = "welcome";

    if (companyStore.companyOnboardingStatus !== "") {
      routeName = getOnBoardRoute(companyStore.companyOnboardingStatus);
    }

    return next({
      name: routeName,
    });
  }

  return next();
}
